/** Canonical entity types for portal onboarding and admin repair. */
export const ENTITY_TYPES = [
  'LLC',
  'Corporation',
  'Nonprofit',
  'Sole Proprietorship',
  'Partnership',
  'Other',
];

export const PROFILE_STATUS = {
  INCOMPLETE: 'incomplete',
  ACTIVE: 'active',
};
